import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=6ef0273c&scoped=true"
import script from "./MenuTree.vue?vue&type=script&lang=js"
export * from "./MenuTree.vue?vue&type=script&lang=js"
import style0 from "./MenuTree.vue?vue&type=style&index=0&id=6ef0273c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef0273c",
  null
  
)

export default component.exports